import React from 'react'

interface ContainerProps {
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'fluid'
}

export default function Container({
  children,
  size,
}: ContainerProps) {
  return (
    <div className={size ? `container-${size}` : 'container'}>
      {children}
    </div>
  )
}
